import { Translation as Tr } from "../class/Translation.js";

function pat_odkazy() {
  var $kod = "";

  $kod += '<div class="vrch">';

  var $valMenu = Tr.obj("pata_odkazy_neon");
  Lc.log("$valMenu", $valMenu);
  for (var $k in $valMenu) {
    var $val = $valMenu[$k];

    $kod += '<div class="dv">';
    $kod += "<h3>" + $k + "</h3>";
    $kod += "<ul>";
    for (var $c in $val) {
      var $link = $val[$c];

      $kod += '<li><a href="' + $link + '">' + $c + "</a></li>";
    } //for
    $kod += "</ul></div>";
  } //for

  //---posledni box s logem
  $kod += '<div class="last">';
  $kod +=
    '<div id="dvLogo"><a href="/" class="logo"><img src="' +
    $shoptetUpload +
    '/5m_logo_v1.png" alt="" height="44" width="82"></a></div>';
  $kod += "<h3>" + Tr.l("pata_sledujte_nas") + "</h3>";
  $kod += '<div class="social">';
  //var $arr=['facebook','twitter','google_plus'];
  var $arr = ["facebook", "instagram", "youtube"];
  $arr.forEach(function(entry) {
    $kod +=
      '<a  class="' +
      entry +
      '" href="' +
      window.kontakty[entry] +
      '"><img src="' +
      $shoptetUpload +
      "/pata/" +
      entry +
      '.png" alt=""></a>';
  });

  $kod += '</div><!-- class="social"-->';

  $kod += '</div><!-- class="last"-->';

  $kod += '</div><!-- class="vrch"-->';

  $kod +=
    '<div class="spodek"><span class="cz">Česká republika</span></div><!-- class="spodek"-->';

  $('<div id="dvP"><div class="cntmax">' + $kod + "</div></div>").insertAfter(
    "#footer"
  );
} //function  pat_odkazy()

function zobrazPatickuStranky() {
  //---------spodni radek
  //<p><span class="spnP">Individuální úpravy navrhlo a implementovalo studio <a href="https://shoptet.ladzo.cz/"><span class="non">Corux.cz</span></a></span> <a class="adm" href="https://www.shoptet.cz/">Administrace <img src="https://cdn.myshoptet.com/prj/fdf332c9/master/cms/img/shoptetLogo17x17.gif" width="17" height="17" alt="Shoptet.cz" class="vam"> Shoptet</a> </p>                                                \
  $(
    '<div id="dvPata"><div class="container">    \
    <p><span class="spnP"> <a href="https://shoptet.ladzo.cz/">shoptet.Ladzo.cz</a></span> <a class="adm" href="https://www.shoptet.cz/">, <img src="https://cdn.myshoptet.com/prj/0c160e08/master/cms/img/common/logo/shoptetLogo.svg" width="17" height="17" alt="Shoptet.cz" class="vam"> Shoptet</a> </p>                                                \
    </div></div>'
  ).insertAfter("footer");
} //function zobrazPatickuStranky(){

export function zobrazPatu() {
  zobrazPatickuStranky();
  pat_odkazy();
} //export function  zobrazPatu()
